import { render, staticRenderFns } from "./EmailStatusModal.vue?vue&type=template&id=055e5b27&scoped=true&lang=pug"
import script from "./EmailStatusModal.vue?vue&type=script&lang=js"
export * from "./EmailStatusModal.vue?vue&type=script&lang=js"
import style0 from "./EmailStatusModal.vue?vue&type=style&index=0&id=055e5b27&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "055e5b27",
  null
  
)

export default component.exports